import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=dcd5deec&"
import script from "./BookingDetails.vue?vue&type=script&lang=js&"
export * from "./BookingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports